<template>
  <button class="audio-current-timecode">
    · <span class="audio-current-timecode__txt">{{ text }}</span>
  </button>
</template>

<script setup>
  const props = defineProps({
    text: { type: String }
  });
</script>

<style lang="scss" scoped>
  @import "./styles";
</style>